import Vue from 'vue'
import Vuex from 'vuex'

import { setStore, getStore } from '../config/utils'

Vue.use(Vuex)

const state = {
  bgmStatus: getStore('bgmStatus'),
  openId: getStore('openId'),
  staticData: getStore('staticData')
}

export default new Vuex.Store({
  state,
  mutations: {
    changeBgmStatus(state) {
      if (state.bgmStatus === 'off') {
        state.bgmStatus = 'on'
        setStore('bgmStatus', 'on')
      } else {
        state.bgmStatus = 'off'
        setStore('bgmStatus', 'off')
      }
    },
    setBgmStatus(state, setting) {
      state.bgmStatus = setting.status
      setStore('bgmStatus', setting.status)
    },
    setOpenIdStatus(state, openId) {
      state.openId = openId
      setStore('openId', openId)
    },
    setStaticDataStatus(state, staticData) {
      state.staticData = staticData
      setStore('staticData', staticData)
    }
  },
  actions: {
    changeBgmSetting(context) {
      context.commit('changeBgmStatus')
    },
    setBgmSetting(context, status) {
      context.commit('setBgmStatus', status)
    },
    setOpenId(context, status) {
      context.commit('setOpenIdStatus', status)
    },
    setStaticData(context, status) {
      context.commit('setStaticDataStatus', status)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js